import { render, staticRenderFns } from "./MainFab.vue?vue&type=template&id=22b49b39"
import script from "./MainFab.vue?vue&type=script&lang=js"
export * from "./MainFab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports